export default __webpack_public_path__ + "static/media/2.64b5bfd6.jpg";